export default __webpack_public_path__ + "static/media/i-nacionalidade.471ad975.png";